import { Component, Input } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

import { ROTAS } from '@routingModule';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'smrts-menu-usuario',
  templateUrl: './menu-usuario.component.html',
  styleUrls: ['./menu-usuario.component.scss'],
  standalone: false
})
export class MenuUsuarioComponent {

  @Input() menuDrawer: MatDrawer;

  get username(): string {
    return this.authService.getLogin()?.toUpperCase() ?? '';
  }

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  public onDadosConta(): void {
    this.menuDrawer.toggle();
    this.router.navigate([ROTAS.dadosConta]);
  }

  public onLogout(): void {
    this.menuDrawer.toggle();

    this.authService.logout();
    this.router.navigate([ROTAS.login]);
  }
}
